export class SubmitCaseAssignModel {
  studentSk: number;
  personInfo: PersonInfo;
  
  constructor(data: any) {
    //TODO:We need to add types for the api endpoints, once added we need to add the types to the constructor method

    this.studentSk = data?.studentSk;
    this.personInfo = new PersonInfo(
      data?.personInfo,
      data?.searchStudentDetails
    );
  }
}

export class PersonInfo {
  firstName: string;
  lastName: string;
  email: string;
  personSk: string;
  userName: string;
  constructor(data: any, details: any) {
    //TODO:We need to add types for the api endpoints, once added we need to add the types to the constructor method
    this.firstName = details?.firstName;
    this.lastName = details?.lastName;
    this.email = details?.email;
    this.personSk = data?.personSk;
    this.userName = details?.loginId;
  }
}
